import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { NameCustomizeComponent } from 'app/e-form/dialog/name-customize/name-customize.component';
import { EFormHelper } from 'app/e-form/helper/script/helper';
import { State } from 'app/e-form/model/eform-type';
import { Observable, Subscription } from 'rxjs';

@Component({
   selector: 'app-name-properties',
   templateUrl: './name-properties.component.html',
   styleUrls: ['./name-properties.component.scss']
})
export class NamePropertiesComponent implements OnInit, OnDestroy {
   @Input() eForm: FormGroup;
   @Input() state: State;
   @Output() sendFocus = new EventEmitter<boolean>();
   @Input() clickEvents: EventEmitter<string>;
   helper = new EFormHelper();
   eventSub: Subscription;
   displayDisabled: boolean;
   @Input() eventsStateChild: Observable<void>;

   constructor(private dialog: MatDialog) { }

   ngOnInit(): void {
      this.helper.checkDisplayDisabled(this.eForm, this.state);
      this.helper.displayDisabledChanges.subscribe((value) => {
         this.displayDisabled = value;
      });
      this.eventSub = this.eventsStateChild.subscribe(() => {
         this.helper.checkDisplayDisabled(this.eForm, this.state);
      });
   }

   ngOnDestroy(): void {
      if (this.eventSub) {
         this.eventSub.unsubscribe();
      }
   }

   onCheckboxValueChange(formType: 'title' | 'middleName' | 'initial', checked: boolean) {
      if (!checked) {
         this.disableControl(formType);
         this.changeType(1);
      } else {
         if (formType === 'title') {
            const title =  this.getField.controls.title as FormGroup;
            title.controls.type.setValue(0);
         }
         this.enableControl(formType);
      }
      this.helper.getFieldAsFormArray(this.eForm, this.state.sectionIndex).updateValueAndValidity();
   }

   disableControl(formType: string) {
      const _formGroup = this.getField.get(formType) as FormGroup;
      _formGroup.controls.required?.disable();
      _formGroup.controls.required?.setValue(false);
      _formGroup.controls.include?.setValue(false);
   }

   enableControl(formType: string) {
      const _formGroup = this.getField.get(formType) as FormGroup;
      _formGroup.controls.required?.enable();
      _formGroup.controls.required?.setValue(true);
      _formGroup.controls.include?.setValue(true);
   }

   changeType(value) {
      const title =  this.getField.controls.title as FormGroup;
      const customizeData = title.controls.customizeData as FormArray;
      Object.keys(customizeData.controls).forEach(index => {
         const _tmpGroup = customizeData.controls[index].controls as FormControl;
         const _tmpControl = _tmpGroup[this.eForm.controls.original.value] as FormControl;
         if (value !== 2) {
            _tmpControl.clearValidators();
         } else {
            _tmpControl.setValidators(Validators.required);
         }
         _tmpControl.updateValueAndValidity();
      });
   }

   get getField() {
      return this.helper.getFieldAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex);
   }

   get getTittle() {
      return this.getField.get('title') as FormGroup;
   }

   _getValue(type: string) {
      return this.helper.getFieldSomeValue(this.eForm, type, this.state.sectionIndex, this.state.fieldIndex);
   }

   setField(type: string) {
      const _group = this.getField.get(type) as FormGroup;
      return _group.controls.defaultValue;
   }

   sendFocusToCreate(focus: boolean) {
      this.sendFocus.emit(focus);
   }

   openCustomizeDialog() {
      const _formGroup = this.getField.get('title') as FormGroup;
      const _custmize = _formGroup.get('customizeData') as FormArray;
      const _data = { field : _custmize, eForm : this.eForm };
      const _dialog = this.dialog.open(NameCustomizeComponent, {disableClose : true, data: _data});
      _dialog.afterOpened().subscribe(() => this.sendFocusToCreate(false));
      _dialog.afterClosed().subscribe(() => this.sendFocusToCreate(true));
   }

   private delaysActions(_formGroup: FormGroup, action: string): void {
      action === 'disabled' ?
      setTimeout(() => { _formGroup?.controls.required.disable(); }, 200) :
      setTimeout(() => { _formGroup?.controls.required.enable(); }, 200);
   }

}
